import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Button,
  Container,
  Typography,
  Grid,
  Paper,
  CircularProgress,
} from '@mui/material';
import GoogleButton from 'react-google-button';
import { useUserAuth } from '../../context/UserAuthContext';
import Logo from '../../assets/MendocinoFarms_Logo_Horizontal_RGB_FullColor.png';

import './Login.css';

const styles = {
  signInButton: {
    margin: 24,
    minWidth: 260,
    padding: '10px 16px',
    backgroundColor: '#2F2F2F',
    color: '#ffffff',
    textTransform: 'none',
    fontFamily: 'Segoe UI, Lato, sans-serif',
  },
  googleButton: {
    marginTop: 8,
    marginBottom: 24,
  },
};

// Four-tile Microsoft logo rendered inline so we don't need a new asset dep.
const MicrosoftLogo = () => (
  <svg width='18' height='18' viewBox='0 0 23 23' aria-hidden='true' style={{ marginRight: 10 }}>
    <rect x='1'  y='1'  width='10' height='10' fill='#F25022' />
    <rect x='12' y='1'  width='10' height='10' fill='#7FBA00' />
    <rect x='1'  y='12' width='10' height='10' fill='#00A4EF' />
    <rect x='12' y='12' width='10' height='10' fill='#FFB900' />
  </svg>
);

const Login = () => {
  const [error, setError] = useState('');
  const { googleSignIn, microsoftSignIn, loading } = useUserAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const adminMode = new URLSearchParams(location.search).get('admin') === '1';

  const handleMicrosoftSignIn = async (e) => {
    e.preventDefault();
    try {
      await microsoftSignIn();
      navigate('/home');
    } catch (err) {
      console.log(err.message);
      setError(err.message || 'Sign-in failed.');
    }
  };

  const handleGoogleSignIn = async (e) => {
    e.preventDefault();
    try {
      await googleSignIn();
      navigate('/home');
    } catch (err) {
      console.log(err.message);
      setError(err.message || 'Sign-in failed.');
    }
  };

  return (
    <Container component='main' maxWidth='xs' style={{ height: '125vh' }}>
      <div id='background-container'></div>
      <Paper elevation={3} id='paper-container'>
        <img style={{ width: '100%' }} alt='Logo' src={Logo} />
        <Typography style={{ marginTop: 20, fontFamily: 'Lato' }} variant='h5'>
          Support Happy
        </Typography>
        {error && <Typography color='error'>{error}</Typography>}
        <Grid container justifyContent='center' direction='column' alignItems='center'>
          {loading ? (
            <CircularProgress style={{ margin: 36 }} />
          ) : (
            <>
              <Button
                variant='contained'
                onClick={handleMicrosoftSignIn}
                style={styles.signInButton}
                startIcon={<MicrosoftLogo />}
              >
                Sign in with Microsoft
              </Button>
              {adminMode && (
                <div style={styles.googleButton}>
                  <GoogleButton onClick={handleGoogleSignIn} type='dark' />
                </div>
              )}
            </>
          )}
        </Grid>
      </Paper>
    </Container>
  );
};

export default Login;
